import React from "react";
import { Button } from "@/components/ui/button";
import { MessageSquare } from "lucide-react";
import { useAppSelector } from "@/store/hooks";

interface Chat8MessagesButtonProps {
  onClick: () => void;
  className?: string;
  variant?: "default" | "outline" | "ghost";
  size?: "default" | "sm" | "lg" | "icon";
  showCount?: boolean;
}

/**
 * Chat8MessagesButton - Botão para abrir o modal de mensagens
 * Exibe contador de mensagens e pode ser customizado
 */
export const Chat8MessagesButton = React.forwardRef<
  HTMLButtonElement,
  Chat8MessagesButtonProps
>(({
  onClick,
  className = "",
  variant = "outline",
  size = "icon",
  showCount = true
}, ref) => {
  // Obter contagem de mensagens do Redux
  const chatState = useAppSelector((state) => state.chat);
  const messagesCount = chatState?.messages?.length || 0;

  return (
    <div className="flex items-center">
      <Button
        ref={ref}
        variant={variant}
        size={size}
        onClick={onClick}
        className={`bg-gray-800 border-gray-600 text-gray-200 hover:bg-gray-700 relative ${className}`}
        aria-label="Abrir histórico de mensagens"
      >
        <MessageSquare className="h-4 w-4" />
        {showCount && messagesCount > 0 && (
          <span className="absolute -top-2 -right-2 px-1.5 py-0.5 text-xs bg-blue-600 text-white rounded-full min-w-[18px] flex items-center justify-center">
            {messagesCount}
          </span>
        )}
      </Button>
    </div>
  );
});

Chat8MessagesButton.displayName = 'Chat8MessagesButton'; 